import { useQuery } from "react-query";
import { axiosClient } from "@/services/utilities";

interface TagItem {
    tag: string;
    doc_count: number;
}

interface ApiTagsResponse {
    tags: TagItem[];
    total: number;
}

const fetchApiTags = async (): Promise<string[]> => {
    const res = await axiosClient.get<ApiTagsResponse>("/apis/tags");

    const rawTags = res.data?.tags ?? [];

    // mapping hanya ambil string-nya
    return rawTags.map(t => t.tag);
};

export const useApiTags = () => {
    const query = useQuery(["apiTags"], fetchApiTags, {
        staleTime: 1000 * 60,
    });

    return {
        tags: query.data ?? [],
        isLoading: query.isLoading,
        error: query.error,
    };
};
